"use client";
import React, { createContext, useState, useContext, useEffect } from "react";
import { UserService } from "../services/User.service";
import { setAuthorizationToken } from "../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const getCurrentUser = async () => {
    try {
      await UserService.getUser();
      setIsAuthenticated(true);
    } catch (e) {
      if (!error.response.status) {
        setIsAuthenticated(false);
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setAuthorizationToken(token);
      getCurrentUser();
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
